// extracted by mini-css-extract-plugin
export var editInput = "_f3-0";
export var editInputCompact = "_f3-2";
export var editInputLarge = "_f3-1";
export var editInputSmall = "_f3-3";